<template>
  <div>
    <div v-if="loading">
      <hr />
      <hr />
      <hr />
    </div>
    <div v-else>
      <header-component title="
      Sacando mi cita en línea
      " map="false" />
      <rank-component v-on:tramiteActivo="activarTramite()" />

      <div class="container">
        <br />
        <section>
          <b-steps
            v-model="activeStep"
            :animated="isAnimated"
            :rounded="isRounded"
            :has-navigation="false"
            :icon-prev="prevIcon"
            :icon-next="nextIcon"
            :label-position="labelPosition"
          >
            <b-step-item step="1" :label="labelTramite" :clickable="tramiteSelected != -1">
              <div class="columns">
                <div class="column">
                  <div v-for="(tramite, index) in tramites" :key="index" class="card">
                    <a href="#">
                      <div @click="setTramite(index)" class="card-content">
                        <div class="media">
                          <div class="media-content">
                            <p class="title is-4">{{ tramite.name.toUpperCase() }}</p>
                          </div>
                        </div>

                        <div v-if="tramite.resumen" class="content">
                          {{ tramite.resumen }}
                          <br />
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </b-step-item>

            <b-step-item
              step="2"
              :label="labelTipo"
              :clickable="tipoTramiteSelected != -1"
              :type="{ 'is-success': isProfileSuccess }"
            >
              <div class="columns">
                <div class="column">

                  <div v-for="(tipoTramite, index) in tipoTramites" :key="index" class="card">
                    <a>
                      <div @click="setTipoTramite(index)" class="card-content">
                        <div class="media">
                          <div class="media-content">
                            <p class="title is-4">{{ tipoTramite.name.toUpperCase() }}</p>
                          </div>
                        </div>

                        <div v-if="tipoTramite.resumen" class="content">
                          {{ tipoTramite.resumen }}
                          <br />
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </b-step-item>

            <b-step-item step="3" label="Requisitos" :clickable="requisistosCheck != -1">
              <div class="content">
                <h3 v-if="this.tipoTramiteSelected == -1" class="title">{{ "REQUISITOS DE " }}</h3>
                <h3 v-else class="title">
                  {{
                  "REQUISITOS DE " +
                  this.tipoTramites[
                  this.tipoTramiteSelected
                  ].name.toUpperCase()
                  }}
                </h3>
                <p v-html="requisitos"></p>
                <!-- <ul type="1">
                <li v-for="punto in requisitos.puntos" :key="punto">
                  {{ punto }}
                </li>
                <br />
                </ul>-->
                <!-- <label>
                  Para agilizar los tramites puede ingresar algunos documentos
                  digitales. Este paso no es obligatorio.
                </label>-->
                <br />
                <!-- <b-field class="file">
                  <b-upload v-model="file" multiple>
                    <a class="button is-info">
                      <b-icon icon="upload"></b-icon>
                      <span>Subir documentos digitales.</span>
                    </a>
                  </b-upload>
                  <span class="file-name" v-if="file">
                    {{ file.name }}
                  </span>
                </b-field>-->
                <b-button @click="crearCita()" type="is-primary">Crear cita.</b-button>
              </div>
            </b-step-item>

            <b-step-item
              :step="showSocial ? '4' : '3'"
              label="Crear Cita"
              :clickable="isStepsClickable"
              disabled
            >
              <section>
                <div class="field">
                  <b-field
                    label="Por favor ingrese el número de contácto y el método de comunicación."
                  >
                    Número de contácto:
                    <b-input
                      placeholder="Ingrese el número de contácto"
                      type="phone"
                      icon="phone"
                      v-model="phone"
                    ></b-input>
                  </b-field>
                </div>
                <h4>Método de comunicación:</h4>
                <br />
                <div class="field">
                  <b-radio v-model="contactType" native-value="Whatsapp">
                    <b-icon icon="whatsapp"></b-icon>Whatsapp
                  </b-radio>
                </div>
                <div class="field">
                  <b-radio v-model="contactType" native-value="Video Llamada">
                    <b-icon icon="camera-front"></b-icon>Video Llamada
                  </b-radio>
                </div>

                <div class="field">
                  <b-radio v-model="contactType" native-value="Llamada Telefonica">
                    <b-icon icon="cellphone"></b-icon>Llamada Telefónica
                  </b-radio>
                </div>
                <h4>Si gusta puede especificar un trabajador (puede demorar un poco más en ser atendido):</h4>
                <b-field>
                  <b-select v-model="worker_id" placeholder="Todos" icon="account">
                    <option value="null">Todos</option>
                    <option
                      v-for="(trabajador, index) in trabajadores"
                      :key="index"
                      :value="trabajador.id"
                      class="capitalize"
                    >{{trabajador.name}}</option>
                  </b-select>
                </b-field>
                <b-message
                  title="Ya tengo una cita"
                  type="is-primary"
                  v-if="tramiteActivo"
                  active.sync="true"
                  aria-close-label="Close message"
                >
                  Ya tiene una cita en curso. Por favor, revise el cuadro de
                  arriba.
                </b-message>
                <b-message
                  title="Esta fuera del horario de atención."
                  type="is-warning"
                  v-if="horario"
                  active.sync="true"
                  aria-close-label="Close message"
                >
                 El horario de atención es de las 9:00 am - 5:00 pm de Lunes a Sábado. Ya no es posible hacer una cita. Las citas están disponibles solo en el horario de atención.
                </b-message>
                <b-field label="Nos comunicaremos con usted una vez sea su turno.">
                  <b-button @click="crearTicket()" type="is-primary" :disabled="horario">Realizar Cita</b-button>
                </b-field>
              </section>
            </b-step-item>
          </b-steps>
        </section>
      </div>
    </div>

    <b-modal :active.sync="registerModal" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <register-component v-on:correctRegister="crearTicket" />
    </b-modal>
  </div>
</template>
<style lang="scss">
.card:hover {
  background-color: $primary;
  * {
    color: $white;
  }
}
.capitalize {
  text-transform: capitalize;
}
</style>
<script>
/*<img src="{{asset('img/notariaVilca.jpg')}}" />*/
import HeaderComponent from "@/components/HeaderComponent.vue";
import RankComponent from "@/components/RankComponent.vue";
import RegisterComponent from "@/components/RegisterComponent.vue";

export default {
  components: {
    HeaderComponent,
    RankComponent,
    RegisterComponent
  },
  created() {},
  mounted() {
    console.log("Example Component mounted.");
    if (this.$store.state.login == false) {
      this.confirmUser();
    }
    this.loading = true;
    this.$http.get(this.$store.state.url + "/api/tramites").then(response => {
      console.log(response);
      this.$store
        .dispatch("setTramites", response.data.success.tramites)
        .then(() => {
          console.log(this.$store.state);
          this.tramites = this.$store.state.tramites;
          this.loading = false;
        });
    });
    // this.confirmUseterms();
    var today = new Date();   
    // console.log("TODAY",today.getHours());
    // console.log("TODAY",today.getDay());
    if(today.getHours()>=9 && today.getHours()<=17 && today.getDay()!=0){
      this.horario=false;
    }else{
      this.horario=true
    }
  },
  methods: {
    getTrabajadoresList(area_id) {
      const form = new FormData();
      form.append("area_id", area_id);
      this.$http
        .post(this.$store.state.url + "/api/trabajadores", form)
        .then(response => {
          this.trabajadores = response.data.success.trabajadores;
        });
    },
    activarTramite() {
      this.tramiteActivo = true;
    },
    setOtros(){

      this.activeStep += 2;
      this.phone = this.$store.state.user.phone;
      this.sub_area = null;
      this.area = this.tramites[this.tramiteSelected].id;
    },
    crearTicket() {
      const form = new FormData();
      if (this.phone == "") {
        this.$buefy.dialog.alert(
          "Por favor, ingrese un número de teléfono válido."
        );
        return;
      }
      if (this.$store.state.login == false) {
        this.$buefy.dialog.confirm({
          title: "Hubo un error con su usuario",
          message:
            "Por favor, ingrese a su cuenta para realizar la cita en el menu de arriba usando la opción 'Mi cuenta'. Si aún no está registrado puede hacerlo haciendo clic en Registrarme.",
          confirmText: "Registrarme",
          type: "is-warning",
          onConfirm: () => {
            this.registerModal = true;
          }
        });
        return;
      }
      form.append("sub_area_id", this.sub_area);
      form.append("area_id", this.area);
      form.append("phone", this.phone);
      form.append("contactType", this.contactType);
      if (this.worker_id != null && this.worker_id != "null") {
        form.append("worker_id", this.worker_id);
      }

      this.$http
        .post(this.$store.state.url + "/api/ticket", form, {
          headers: {
            Authorization: "Bearer " + this.$store.state.user.token
          }
        })
        .then(response => {
          this.$router.push("/usuario");
          console.log(response);
        });
    },
    setTramite(id) {
      this.getTrabajadoresList(this.tramites[id].id);
      this.labelTipo = "Tipo de trámite";
      this.tramiteSelected = id;
      this.labelTramite = this.tramites[
        this.tramiteSelected
      ].name.toUpperCase();
      this.tipoTramites = this.tramites[this.tramiteSelected].tipos;
      this.activeStep += 1;
    },
    setTipoTramite(id) {
      this.tipoTramiteSelected = id;
      this.requisitos = this.tipoTramites[
        this.tipoTramiteSelected
      ].requirements;
      this.labelTipo = this.tipoTramites[
        this.tipoTramiteSelected
      ].name.toUpperCase();
      this.activeStep += 1;
      this.phone = this.$store.state.user.phone;
      this.sub_area = this.tipoTramites[this.tipoTramiteSelected].id;
      this.area = this.tramites[this.tramiteSelected].id;
    },
    crearCita() {
      this.activeStep += 1;
      this.requisistosCheck = 1;
    },
    confirmUser() {
      this.$buefy.dialog.confirm({
        title: "No estoy registrado",
        message: `Para poder iniciar consultas en linea es necesario que ingrese a mi cuenta.`,
        confirmText: "Ingresar",
        cancelText: "Registrarme luego",
        type: "is-info",
        hasIcon: true,
        icon: "card-account-details",
        onConfirm: () => this.$router.push("/ingresar")
      });
    },
    confirmUseterms() {
      this.$buefy.dialog.confirm({
        title: "Aviso al usuario",
        message: `Todos los documentos que se envien por esta plataforma deben ser originales, ya que se realizara una verificacion de estos antes de la entrega de documentos.`,
        confirmText: "Confirmar",
        type: "is-warning",
        canCancel: false,
        hasIcon: true,
        icon: "text-box-check",
        onConfirm: () => this.$buefy.toast.open("User agreed")
      });
    }
  },
  data() {
    return {
      labelTramite: "Trámite a realizar",
      labelTipo: "Tipo de trámite",
      tramiteActivo: false,
      tramites: "",
      tipoTramites: "",
      tramiteSelected: -1,
      tipoTramiteSelected: -1,
      requisitos: "",
      phone: "",
      loading: true,
      contactType: "Llamada Telefonica",
      codigo: "",
      isActive: true,
      sub_area: 1,
      area: 1,
      horario:true,
      radioButton: "",
      imgHome: process.env.MIX_APP_URL + "img/notariaVilca.jpg",
      cuerpoDocumento:
        "El contenido del documento aparecera aqui. Recuerde que solo tiene 3 consultas por dia.",
      activeStep: 0,
      requisistosCheck: -1,
      showSocial: false,
      isAnimated: true,
      isRounded: true,
      isStepsClickable: false,
      file: {},
      hasNavigation: true,
      customNavigation: false,
      isProfileSuccess: false,

      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      labelPosition: "bottom",
      registerModal: false,
      trabajadores: null,
      worker_id: null
    };
  }
};
</script>
